import { IColorPalette } from '../../typings/semantic/colorPalette';
import ISemanticTopicBase from '../../typings/semantic/semanticTopic';
import MoreLessContainer from './moreLessContainer';
import Topic from './topic';
import VocbularyCollapseHeader from './vocabularyCollapseHeader';
import { Collapse } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useState } from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			gap: '0.5rem'
		}
	})
);

export interface IVocabularyCollapseProps {
	vocabularyName: string;
	collapsed?: boolean;
	topics: ISemanticTopicBase[];
	palette: IColorPalette;
	className?: string;
	onTopicClick: (topic: ISemanticTopicBase) => void;
	onNavigateClick?: (topic: ISemanticTopicBase, previous: boolean) => void;
	onCollapseChanged?: (collapsed: boolean) => void;
	onShowChunksChanged?: (chunksCount: number) => void;
	showChunks?: number;
	onVocabularyClick?: (selected: boolean) => void;
	tooltip?: string;
	testId?: string;
	selected?: boolean;
}

const VocabularyCollapse: React.FunctionComponent<IVocabularyCollapseProps> = ({ topics, ...props }) => {
	const classes = useStyles();
	const [collapsed, setCollapsed] = useState(props.collapsed ?? false);
	const [shownChunks, setShownChunks] = useState(props.showChunks ?? 1);
	const expandStep = 5;
	const transitionTimeout = 300;
	const transitionPerTopicTimeout = transitionTimeout / expandStep;

	if (topics.length === 0) {
		return <></>;
	}

	return (
		<div className={clsx(classes.root, props.className)} data-test-id={props.testId || 'vocabulary-section'}>
			<VocbularyCollapseHeader
				selected={props.selected}
				vocabularyName={props.vocabularyName}
				collapsed={collapsed}
				onCollapseClick={c => {
					setCollapsed(c);

					if (props.onCollapseChanged) {
						props.onCollapseChanged(c);
					}
				}}
				onVocabularyClick={() => {
					if (props.onVocabularyClick) {
						props.onVocabularyClick(props.selected);
					}
				}}
				tooltip={props.tooltip}
			/>
			<Collapse
				in={!collapsed}
				timeout={transitionPerTopicTimeout * Math.min(expandStep, topics.length)}
				unmountOnExit
			>
				<MoreLessContainer
					step={expandStep}
					shownChunks={shownChunks}
					onShownChunksChange={newShownChunks => {
						setShownChunks(newShownChunks);

						if (props.onShowChunksChanged) {
							props.onShowChunksChanged(newShownChunks);
						}
					}}
				>
					{topics.map((topic, i) => (
						<Topic
							onTopicClick={() => {
								props.onTopicClick(topic);
							}}
							onNavigateClick={
								props.onNavigateClick
									? (previous: boolean) => {
											props.onNavigateClick(topic, previous);
									  }
									: null
							}
							key={i}
							{...topic}
						/>
					))}
				</MoreLessContainer>
			</Collapse>
		</div>
	);
};

export default VocabularyCollapse;
